import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/types'

import createStore from '@/store'

Vue.use(Vuex)

const store: StoreOptions<RootState> = createStore()

export default store
